import { render, staticRenderFns } from "./pageTop.vue?vue&type=template&id=2089b435&scoped=true&"
import script from "./pageTop.vue?vue&type=script&lang=js&"
export * from "./pageTop.vue?vue&type=script&lang=js&"
import style0 from "./pageTop.vue?vue&type=style&index=0&id=2089b435&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2089b435",
  null
  
)

export default component.exports